import { Button, Divider, List, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import HomePagePreview from "./HomePagePreview";
import DataCommon from "../ui/DataCommon";
import moment from "moment";

export default function HomePagePublish() {

  const [query, setQuery] = useState({ skip: 0, limit: 20 });
  const [data, setData] = useState<{ count: number, data: any[] }>()
  const [reserve, setReserve] = useState<any[]>()
  const [selected, setSelected] = useState<any>()

  function fetchLast(publish = false) {
    axios.post('cms/homepage').then(({ data }) => {
      setReserve(data.filter((i: any) => i.show));
      if (publish) {
        axios.post('cms/publish').then(() => {
          find()
        })
      }
    })
  }

  function find() {
    axios.post('cms/findpublish', query).then(({ data }) => {
      setData(data)
    })
  }

  useEffect(find, [query])

  useEffect(() => {
    if (!selected) {
      fetchLast()
    }
  }, [selected])

  return <Stack direction={"row"} sx={{ mt: 2 }} spacing={2}>
    <Stack sx={{ pl: 2 }} flexGrow={1}>
      <List sx={{ minWidth: 500 }}>
        <ListItemButton selected={!selected} onClick={() => setSelected(undefined)}>
          <ListItemText primary={"待发布"}></ListItemText>
        </ListItemButton>
      </List>
      <Typography variant="caption">已发布版</Typography>
      <List sx={{ minWidth: 500 }}>
        {data?.data?.map((i, index) => <ListItemButton
          selected={selected?._id === i._id}
          key={index} onClick={() => setSelected(i)}>
          <ListItemText secondary={moment(i.pubDate).format('yyyy-MM-DD HH:mm:ss')} primary={`${i.member.mobile} - ${i.member.name}`}></ListItemText>
        </ListItemButton>)}
      </List>
      <DataCommon query={query} setQuery={setQuery} data={data} />
    </Stack>
    {(selected || reserve) && <Stack spacing={2} flexGrow={1}>
      <HomePagePreview data={!selected ? reserve : selected.config}></HomePagePreview>
      {!selected && <Button sx={{ width: 300 }} variant="contained" onClick={() => {
        fetchLast(true)
      }}>发布</Button>}
    </Stack>}
  </Stack>
}